import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "jr-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "jr-text-primary jr-mb-5 jr-text-base" }, "属性情報（性別・年代別比）", -1)
const _hoisted_3 = { class: "jr-border jr-py-7 jr-px-18 jr-border-gray-medium jr-rounded-md" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "jr-text-xxs jr--mb-3.5 jr-ml-4" }, "(%)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_BarChart, _mergeProps({ class: "barchart" }, _ctx.barChartProps), null, 16)
    ])
  ]))
}